module.exports = __webpack_public_path__ + "img/stack-overflow-pay-by-language.11968550.png";